module.exports = __webpack_public_path__ + "img/fourth-flight.13b1b55c.png";